// React-router-dom
import {
	// Hooks
	useLocation,
	useNavigate,
	useNavigationType,
	useParams,
	useSearchParams,
	useResolvedPath,
	useRouteError,
	useMatch,
	Navigate,
	Outlet,
	Link,
	type To,
	type LinkProps,

	/**
	 * NavLink components
	 * A <NavLink> is a special kind of <Link> that knows whether or not it is "active", "pending", or "transitioning".
	 */
	NavLink,
	type NavLinkProps,

	// The 6.4 way of doing things
	createBrowserRouter,
	createRoutesFromElements,
	Route,
	RouterProvider,

	// Only used for test-utils and storybook
	createMemoryRouter,
	createRoutesFromChildren,
	matchRoutes,
	matchPath,
} from "react-router-dom"

// Export
export {
	useLocation,
	useNavigate,
	useNavigationType,
	useParams,
	useSearchParams,
	useResolvedPath,
	useMatch,
	useRouteError,
	createRoutesFromChildren,
	createRoutesFromElements,
	matchRoutes,
	matchPath,
	Navigate,
	Link,
	NavLink,
	createBrowserRouter,
	createMemoryRouter,
	Route,
	RouterProvider,
	Outlet,
}

// Export Types
export type { LinkProps, NavLinkProps, To }
export type BrowserRouter = ReturnType<typeof createBrowserRouter>

/**
 * Future options
 *
 * DOCS: https://reactrouter.com/6.28.1/upgrading/future
 *
 * Important: somehow the v7_startTransition flag only works on the RouterProvider and
 * not as an option above on createRoutesFromElements
 *
 */
export const future = {
	v7_startTransition: true,
	v7_relativeSplatPath: true,
	v7_fetcherPersist: true,
	v7_normalizeFormMethod: true,
	v7_partialHydration: true,
	v7_skipActionErrorRevalidation: true,
}
